// not an actual object in the C# code
// see src/TBC.TriumphPay.Web/Models/CoreAPI/Common/InvoiceOrCreditDTO.cs
export enum PayeeInvoiceOrCreditNoteTypeId {
  Invoice = 1,
  CreditNote = 2,
}

export const invoiceLineItemNames = {
  invoiceAdvanceFee: 'Invoice Advance Fee',
  promotionalInvoiceAmount: 'Promotional Invoice Amount',
  quickPay: 'QuickPay Fee',
};

export enum InvoiceStatusId {
  Pending = 1,
  Approved = 2,
  Paid = 3,
  // 4 should not be used
  Held = 5,
  MissingCarrier = 6,
  // 7 should not be used
  Removed = 8,
  // 9 should not be used
  PendingReissue = 10,
  MissingBank = 11,
}
